import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=3c1e35ac&scoped=true&"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=3c1e35ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e35ac",
  null
  
)

export default component.exports